import React, { useEffect, useState, useCallback, Fragment } from 'react';

// Components
import SuperModal2 from "../../../components/coreModal/SuperModal2";
import DocTable from "./docsTable";
import PaymentHistory from "./paymentDocumentHistory";
import NumberFormat from "react-number-format";
import AplicarPagoModal from "./AplicarPagoModal";
import PaginadorParent, { paginadorFilter } from '../../../components/paginador/PaginadorParent';
import TableHeadSort from '../../../components/tables/TableHeadSort';

// Requests
import { getParameters } from '../../../helpers/requests';
import { getDocumentsDetalleByVivienda } from '../helpers/requests';

// Helpers
import sortableData from '../../../helpers/sortableDataTable';

const viviendasPagosDataInit = () => ({
    id_docActivo: 0,
    index_docModal: -1,
    detail: [],
    sort: { name: 'Unidad', direction: 'desc' },
    loading: false,
});

const idEstadoCuentaModal = 'paymentHistory';
const idAplicarPagoModal = 'newPayment';

const sortTable = (docs, key, direction) => {
    let sd = new sortableData();
    const { items } = sd.sortBy(key, docs, direction);

    return items;
};

export default function ViviendasPagosTable(props) {

    const { id = '', docs, loadingDocs, fracName, subfraccionamientos, userName, userId, metodosPago, escritura, onReload } = props;

    const [viviendasPagosData, setViviendasPagosData] = useState(viviendasPagosDataInit);
    const [usoPrelacion, setUsoPrelacion] = useState(false);
    const [subLabel] = useState(window.localStorage.getItem("subLabel") || "");
    const [openModalId, setOpenModalId] = useState('');
    const [{ page, elementsPerPage }, setPaginadorInfo] = useState({ page: 0, elementsPerPage: 20 });

    const { detail, id_docActivo, index_docModal, sort, loading } = viviendasPagosData;

    const pagedDocs = paginadorFilter(docs, page, elementsPerPage);
    const sortedDocs = sortTable(pagedDocs, sort.name, sort.direction);

    const openModalDoc = pagedDocs[index_docModal];
    const { Unidad, Id_Vivienda } = openModalDoc || { Unidad: '', Id_Vivienda: 0 };

    const onUpdateData = useCallback((data) => setViviendasPagosData((prevData) => ({
        ...prevData, ...data
    })), []);

    const loadFacturacionParameters = useCallback(async () => {
        try {

            const id_fraccionamiento = +(localStorage.getItem("frac") || 0);
            const { config } = await getParameters(id_fraccionamiento);

            const campos = JSON.parse(config[0].Campos);
            const campoPrelacion = campos.find(({ id_campo }) => id_campo === 16);

            if (campoPrelacion) {
                const usoPrelacion = campoPrelacion.Valor?.[0]?.valor.toUpperCase() === "SI";
                setUsoPrelacion(usoPrelacion);
            }

        } catch (error) {
            console.log("Loading Facturacion parameters error: ", error);
        }
    }, []);

    useEffect(() => {

        loadFacturacionParameters();

    }, [loadFacturacionParameters]);

    useEffect(() => {

        let active = true;

        (async () => {

            if (id_docActivo !== 0) {

                const { detail } = await getDocumentsDetalleByVivienda(id_docActivo);
                if (active) onUpdateData({ detail, loading: false });
            }

        })();

        return () => { active = false; };

    }, [id_docActivo, onUpdateData]);

    const setDetalleSearch = (id_vivienda) => {

        if (id_vivienda !== id_docActivo)
            onUpdateData({ id_docActivo: id_vivienda, loading: true });
        else
            onUpdateData({ id_docActivo: 0, loading: false });
    };

    const onOpenModal = (idModal, index_docModal) => {

        onUpdateData({ index_docModal });
        setOpenModalId(idModal);
    };

    const onCloseModal = () => {
        onUpdateData({ index_docModal: -1 });
        setOpenModalId('');
    }

    const onPagedDataChanged = ({ page, elementsPerPage }) => setPaginadorInfo({ page, elementsPerPage });

    return (
        <div id="card-owners" className="card-table card-owners column" >
            <table className="full">
                <thead id={id} className="" style={{ position: "sticky", top: "245px", zIndex: 1 }}>
                    <tr className="text-left">
                        <th className="text-start ">
                            <TableHeadSort
                                title={'Vivienda'}
                                orderName={'Unidad'}
                                orderKey={sort}
                                onOrderKeyChange={(newOrder) => onUpdateData({ sort: newOrder })}
                            />
                        </th>
                        <th className="text-start ">
                            <TableHeadSort
                                title={'Propietario'}
                                orderName={'Propietario'}
                                orderKey={sort}
                                onOrderKeyChange={(newOrder) => onUpdateData({ sort: newOrder })}
                            />
                        </th>
                        <th className="text-center">Cargos</th>
                        <th className="text-center">Pagos</th>
                        <th className="text-center">Saldo</th>
                        <th className="text-center">Saldo a favor</th>
                        <th className="text-center th-options">Detalle</th>
                        <th className="text-center th-options">Estado de Cuenta</th>
                        <th className="text-center th-options">Pagar</th>
                    </tr>
                </thead>
                <tbody>
                    {loadingDocs ?
                        <tr>
                            <td colSpan="9" className="text-center">
                                <i className="fas fa-spinner fa-spin"></i>
                            </td>
                        </tr>
                        :
                        sortedDocs.length === 0 ?
                            <tr>
                                <td colSpan="9" className="text-center">
                                    Sin datos que mostrar.
                                </td>
                            </tr>
                            :
                            sortedDocs.map((doc, index) =>
                                <Fragment key={doc.Id_Vivienda}>
                                    <tr className={id_docActivo === doc.Id_Vivienda ? "row-active text-left" : ""}>
                                        <td className="text-start">{doc.Unidad}</td>
                                        <td className="text-start">{doc.Propietario}</td>
                                        <td className="text-right">
                                            <NumberFormat
                                                value={doc.Cargos}
                                                displayType={"text"}
                                                thousandSeparator={true}
                                                prefix={"$"}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                            />
                                        </td>
                                        <td className="text-right">
                                            <NumberFormat
                                                value={doc.Pagos}
                                                displayType={"text"}
                                                thousandSeparator={true}
                                                prefix={"$"}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                            />
                                        </td>
                                        <td className="text-right">
                                            <NumberFormat
                                                value={doc.Saldo}
                                                displayType={"text"}
                                                thousandSeparator={true}
                                                prefix={"$"}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                            />
                                        </td>
                                        <td className="text-right" style={{ color: "#F00" }}>
                                            <NumberFormat
                                                style={doc.Saf === 0 ? { opacity: 0.35 } : undefined}
                                                value={doc.Saf}
                                                displayType={"text"}
                                                thousandSeparator={true}
                                                prefix={"$"}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                            />
                                        </td>
                                        <td>
                                            <button
                                                className="btn-full btn-mini btn-secondary color-white"
                                                type="button "
                                                onClick={() => setDetalleSearch(doc.Id_Vivienda)}
                                            >
                                                <i className="font-small fas fa-info-circle" />
                                            </button>
                                        </td>
                                        <td className="text-right">
                                            <button
                                                className="btn-full btn-mini btn-secondary color-white"
                                                type="button "
                                                onClick={(event) => onOpenModal(idEstadoCuentaModal, index)}
                                            >
                                                <i className="font-small fas fa-file-invoice" />
                                            </button>
                                        </td>
                                        <td className="text-right width-small ">
                                            <button
                                                className="btn-full btn-mini btn-secondary color-white"
                                                type="button "
                                                onClick={(event) => onOpenModal(idAplicarPagoModal, index)}
                                            >
                                                <i className="font-small fas fa-file-invoice-dollar" />
                                            </button>
                                        </td>
                                    </tr>
                                    {id_docActivo === doc.Id_Vivienda ? (
                                        loading ? (
                                            <tr>
                                                <td className="text-center" colSpan="9">
                                                    <i className="fas fa-spinner fa-spin"></i>
                                                </td>
                                            </tr>
                                        ) : (
                                            <tr className="acordeon-row">
                                                <td className="acordeon" colSpan="9">
                                                    <div className="row full">
                                                        <DocTable
                                                            key={doc.Id_Vivienda}
                                                            docs={detail}
                                                            escritura={escritura}
                                                            reload={onReload}
                                                            status={''}
                                                            year={'2025'}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    ) : null}
                                </Fragment>
                            )
                    }
                </tbody>
            </table>
            <div className="white-space-16"></div>
            <PaginadorParent
                data={docs}
                initalElementsPerPage={20}
                onPagedDataChange={onPagedDataChanged}
            />
            <AplicarPagoModal
                id={idAplicarPagoModal}
                visible={openModalId === idAplicarPagoModal}
                viviendaInfo={{ unidad: Unidad, id_vivienda: Id_Vivienda }}
                userInfo={{ userName, userId }}
                enabledPrelacion={usoPrelacion}
                metodosPago={metodosPago}
                onCloseModal={onCloseModal}
                onSuccessfulSubmit={() => {
                    onCloseModal();
                    onReload();
                }}
            />
            <EstadoDeCuentaModal
                id={idEstadoCuentaModal}
                visible={openModalId === idEstadoCuentaModal}
                subfraccionamientos={subfraccionamientos}
                id_vivienda={Id_Vivienda}
                unidad={Unidad}
                fracName={fracName}
                subLabel={subLabel}
                onCloseModal={onCloseModal}
            />
        </div>
    );
}

const EstadoDeCuentaModal = (props) => {

    const {
        id, visible, subfraccionamientos, id_vivienda, unidad,
        fracName, subLabel, onCloseModal
    } = props;

    const screen = [{
        component:
            <PaymentHistory
                subfraccionamientos={subfraccionamientos}
                Id_Vivienda={id_vivienda}
                unidad={unidad}
                fracName={fracName}
                subLabel={subLabel}
            />
    }];

    const cancelProps = SuperModal2.SetFooterCancelProps({ show: true, label: "CANCELAR" });
    const submitProps = SuperModal2.SetFooterSubmitProps({ show: false, label: "NO" });

    return (
        <SuperModal2
            id={id}
            size={"huge"}
            title={"Histórico estados de cuenta"}
            menuScreens={screen}
            openModal={visible}
            cancelProps={cancelProps}
            submitProps={submitProps}
            onCloseModal={onCloseModal}
        />
    );
};
